import { LINK_ABOUTDESTINY, LINK_ABOUTRESONACE, KKDAY_URL } from '@/utils/links';

interface RouteData {
    key: string;
    title: string;
    content: string;
    fullContent: string;
    status: 'contact' | 'open' | 'preparing' | 'closed';
    link: string;
    infos: {
        label: string;
        value: string;
        fullContent?: string;
        hideOnDetailView?: boolean;
    }[];
}

export const route1: RouteData = {
    key: 'aboutlove',
    title: '戀の時光町',
    status: 'open',
    link: KKDAY_URL,

    content: `五個地點串起五個時代

    遇見不同時空的她們，
    有些愛情沒被寫進歷史，
    卻留在恆春古城的街角`,

    fullContent: ``,

    infos: [
        {
            label: '開放時間',
            value: '每週五、六、日',
        },
        {
            label: '體驗時長',
            value: '60 - 90 分鐘',
        },
        {
            label: '地點',
            value: '恆春鎮',
        },
    ],
};

export const route2: RouteData = {
    key: 'aboutdestiny',
    title: '限時轉運站',
    status: 'closed',
    link: LINK_ABOUTDESTINY,

    content: `車水馬龍的老街區
    你將得到一個神奇的虛擬聊天室

    透過與店家互動收集「碎片」
    揭開聊天室背後的神秘面紗
    來趟最具挑戰性的「轉運」之旅吧！`,

    fullContent: `「限時轉運站」是個以恆春老街為背景的真人互動式數位體驗，故事開始於一位生活不順遂的台北男子，特地南下至恆春尋找網戀三個月的女友 Tiffany。男主角帶著滿腔期待，踏上這條前所未有的尋愛之路。隨著他深入恆春老街和收集各種線索，逐步揭開 Tiffany 的真正樣貌⋯⋯

    這條路線將帶著各位深入探索恆春的風土人情，與在地店家互動，收集獨特的圖鑑。透過旅人的選擇，進而影響故事的最終結局；每次的選擇都至關重要，因為，你的決定將決定故事的走向！

    邀請各位旅人來揭開 Tiffany 的神秘面紗，同時將發現老街店家各自擁有的獨特個性與故事。無論是一個人玩，或是與朋友一同挑戰，這條路線都能帶來不同的樂趣與驚喜。出發吧！來場轉變命運的冒險之旅！`,

    infos: [
        {
            label: '開放時間',
            value: '目前暫不開放',
            hideOnDetailView: true,
        },
        {
            label: '體驗時長',
            value: '約 60 分鐘',
        },
        {
            label: '地點',
            value: '恆春老街',
        },
    ],
};

export const route3: RouteData = {
    key: 'aboutresonance',
    title: '共聲電台',
    status: 'contact',
    link: LINK_ABOUTRESONACE,

    content: `共聲電台佇立在島上一隅
    不畏風雨
    默默記錄下從古至今珍貴的聲音
    頻頻發出電波
    路過的你，打開手機尋找吧！`,

    fullContent: `繁忙的工作和生活，旅人們已經多久沒有好好停下來聆聽各種聲響發出的頻率呢？

    心跳的頻率、呼吸的頻率、腳步的頻率⋯⋯在自然界中，還有好多有趣的聲音頻率等待大家去探索。在共聲島上有一座由自然環境、島民與旅人共創的聲音電台。凡是來到電台的旅人，將獲得一台虛擬收音機，它將會引導旅人感應與接收共聲電台的聲音訊號。

    請將這台收音機拿在胸前，像使用指南針一樣，保持螢幕朝上、朝前，自由地行走在「共聲電台」區域，即將聽見一些破碎、不完整、失真、怪異的雜音，以及呢喃的字句。隨著身體轉到不同方向、仔細感受耳機裡聲音的方位，讓聲音保持在身體中心，朝著該方向前進，直到清晰的聲音浮現。每段聲音都結合了不同的地景聲響、動物鳴叫以及島民創作的音樂，聆聽完畢之後，旅人也能將自己的聲音錄製於共聲島電台裡，獲得屬於自己的一段聲音，成為共聲島的一部分。

    邀請旅人們來到共聲電台，透過尋覓、感知、沈浸於不同的聲音頻率，調節生活的頻率。`,

    infos: [
        {
            label: '開放時間',
            value: '僅接20人以上團客',
            hideOnDetailView: true,
        },
        {
            label: '體驗時長',
            value: '約 60 分鐘',
        },
        {
            label: '地點',
            value: '恆春鎮城北里',
            fullContent: '古城東門一帶',
        },
    ],
};

export const routeList = [route1, route2, route3];
